import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-e-edit-address',
  templateUrl: './e-edit-address.component.html',
  styleUrls: ['./e-edit-address.component.css']
})
export class EEditAddressComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
